<template>
	<div class="search-app-version">
		<div class="el-search vue-top-padding radius">
			<div class="el-left">
				<el-button
					type="primary"
					size="small"
					v-hasPerm="['sys:app:version:insert']"
					icon="el-icon-plus"
					@click="addAppVersion"
					>{{ $t("common.add") }}</el-button
				>
			</div>
			<div class="el-right">
				<el-form
					ref="appVersion"
					:model="search"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height"
				>
					<el-form-item prop="appName">
						<el-input
							v-model="search.appName"
							:placeholder="$t('searchAppVersion.appName')"
							@input="onSubmit"
						></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button
							@click="resetSearch('appVersion')"
							icon="el-icon-refresh"
							>{{ $t("common.reset") }}</el-button
						>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchAppVersion",
	props: {
		search: Object,
	},
	methods: {
		onSubmit() {
			this.$emit("onSubmit", this.search);
		},
		resetSearch(formName) {
			this.$refs[formName].resetFields();
			this.$toolUtil.clearForm(this.search);
			this.$emit("resetSearch", this.search);
		},
		addAppVersion() {
			this.$emit("addAppVersion");
		},
	},
};
</script>

<style scoped></style>
